import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import * as React from "react";
import { forwardRef, useMemo, useCallback, useState } from "react";
import { InputCheckbox } from "@creditornot/cb-checkbox";
import { typographyClassName, elevationClassName } from "@creditornot/cb-ingredients";
import { Empty } from "@creditornot/cb-placeholders";
import { Spinner } from "@creditornot/cb-progress";
import { clsx } from "@creditornot/cb-utils";
import { Tooltip, Popover } from "@creditornot/cb-popover";
import { TextButton } from "@creditornot/cb-button";
import { MenuActionItem } from "@creditornot/cb-menu";
import "./style.css";
const SvgCaretdown = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M12.028 19.5c.662 0 1.292-.283 1.73-.778l9.81-11.13a1.84 1.84 0 00-.195-2.568 1.85 1.85 0 00-2.578.134l-8.579 9.732a.25.25 0 01-.376 0L3.262 5.158a1.849 1.849 0 00-3.17.609A1.84 1.84 0 00.49 7.592l9.807 11.126a2.312 2.312 0 001.732.782z" }) }));
const SvgCaretleft = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M4.5 11.972c0-.662.283-1.292.778-1.73l11.13-9.81a1.84 1.84 0 012.568.195 1.85 1.85 0 01-.134 2.578L9.11 11.784a.25.25 0 000 .376l9.732 8.578a1.849 1.849 0 01-.609 3.17 1.84 1.84 0 01-1.825-.397L5.282 13.704a2.312 2.312 0 01-.782-1.732z" }) }));
const SvgCaretright = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M19.5 11.972c0-.662-.283-1.292-.778-1.73L7.592.433a1.84 1.84 0 00-2.568.195 1.85 1.85 0 00.134 2.578l9.732 8.579a.25.25 0 010 .376l-9.732 8.578a1.849 1.849 0 00.609 3.17 1.84 1.84 0 001.825-.397l11.126-9.807a2.312 2.312 0 00.782-1.732z" }) }));
const InfoCircleFilled = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm.25 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75c0 .138.112.25.25.25h.75a1 1 0 010 2z" }) }));
const SvgMorehorizontal = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M20.75 15.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM12 8.75a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm-8.75 0a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5z" }) }));
const _exp$1 = () => SvgCaretdown;
const CaretIcon = /* @__PURE__ */ styled(_exp$1())({
  name: "CaretIcon",
  class: "cb_HeaderColumn_CaretIcon_crcf",
  propsAsIs: true
});
const _exp3$1 = () => CaretIcon;
const InvisibleCaretIcon = /* @__PURE__ */ styled(_exp3$1())({
  name: "InvisibleCaretIcon",
  class: "cb_HeaderColumn_InvisibleCaretIcon_i8tl",
  propsAsIs: true
});
const _exp4$1 = () => ({
  $align
}) => ({
  left: "flex-start",
  center: "center",
  right: "flex-end"
})[$align];
const _exp5 = () => ({
  $align
}) => ({
  left: "start",
  center: "center",
  right: "end"
})[$align];
const Content$1 = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_HeaderColumn_Content_c9d4",
  propsAsIs: false,
  vars: {
    "c9d4dta-0": [_exp4$1()],
    "c9d4dta-1": [_exp5()]
  }
});
const _exp6$1 = () => InfoCircleFilled;
const InfoIcon = /* @__PURE__ */ styled(_exp6$1())({
  name: "InfoIcon",
  class: "cb_HeaderColumn_InfoIcon_ixrt",
  propsAsIs: true
});
const Root$2 = /* @__PURE__ */ styled("th")({
  name: "Root",
  class: "cb_HeaderColumn_Root_rvmr",
  propsAsIs: false
});
const HeaderColumn = ({
  align,
  children,
  className,
  info,
  onKeyDown,
  onSortChange,
  sortDirection,
  sortDirections = [],
  ...rest
}) => {
  const clickable = sortDirections.length > 0;
  const nextSortDirection = useMemo(() => {
    if (sortDirection === "descend" && sortDirections.includes("ascend")) {
      return "ascend";
    } else if (sortDirection === "ascend" && sortDirections.includes("descend")) {
      return "descend";
    } else if (sortDirections.includes("ascend")) {
      return "ascend";
    } else if (sortDirections.includes("descend")) {
      return "descend";
    }
    return sortDirection;
  }, [sortDirection, sortDirections]);
  const handleClick = useCallback(() => {
    if (onSortChange && nextSortDirection) {
      onSortChange(nextSortDirection);
    }
  }, [nextSortDirection, onSortChange]);
  const handleKeyDown = useCallback((event) => {
    if (onSortChange && nextSortDirection && (event.key === " " || event.key === "Enter")) {
      onSortChange(nextSortDirection);
    }
    onKeyDown == null ? void 0 : onKeyDown(event);
  }, [nextSortDirection, onSortChange, onKeyDown]);
  return /* @__PURE__ */ jsx(Root$2, {
    ...rest,
    className: clsx(className, typographyClassName.Subtitle),
    "data-sortable": clickable ? true : void 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    tabIndex: clickable ? 0 : void 0,
    children: /* @__PURE__ */ jsxs(Content$1, {
      $align: align,
      children: [children && /* @__PURE__ */ jsx("div", {
        children
      }), !!sortDirection && /* @__PURE__ */ jsx(CaretIcon, {
        "data-direction": sortDirection === "ascend" ? "up" : "down",
        "data-right": align === "right" ? true : void 0
      }), !sortDirection && sortDirections.length > 0 && /* @__PURE__ */ jsx(InvisibleCaretIcon, {
        "data-direction": sortDirections.includes("ascend") ? "up" : "down",
        "data-right": align === "right" ? true : void 0
      }), !!info && /* @__PURE__ */ jsx(Fragment, {
        children: /* @__PURE__ */ jsx(Tooltip, {
          content: info,
          children: /* @__PURE__ */ jsx(InfoIcon, {})
        })
      })]
    })
  });
};
const noop = () => {
};
const PopoverContent = /* @__PURE__ */ styled("div")({
  name: "PopoverContent",
  class: "cb_PageSizeSelector_PopoverContent_p12u",
  propsAsIs: false
});
const PageSizesList = /* @__PURE__ */ styled("div")({
  name: "PageSizesList",
  class: "cb_PageSizeSelector_PageSizesList_pjf0",
  propsAsIs: false
});
const _exp = () => MenuActionItem;
const StyledMenuActionItem = /* @__PURE__ */ styled(_exp())({
  name: "StyledMenuActionItem",
  class: "cb_PageSizeSelector_StyledMenuActionItem_s1hk",
  propsAsIs: true
});
const PageSizeSelector = ({
  className,
  onChange = noop,
  options,
  value
}) => /* @__PURE__ */ jsx("div", {
  className,
  children: /* @__PURE__ */ jsx(Popover, {
    content: ({
      close
    }) => /* @__PURE__ */ jsx(PopoverContent, {
      children: /* @__PURE__ */ jsx(PageSizesList, {
        children: options.map((option) => /* @__PURE__ */ jsx(StyledMenuActionItem, {
          onClick: () => {
            close();
            onChange(option);
          },
          selected: option === value,
          variant: "black",
          children: option
        }, option))
      })
    }),
    fallbackPlacements: ["top-end"],
    placement: "bottom-end",
    children: ({
      refProps
    }) => /* @__PURE__ */ jsxs(TextButton, {
      ...refProps,
      icon: /* @__PURE__ */ jsx(SvgCaretdown, {}),
      iconPosition: "end",
      children: ["Show ", value]
    })
  })
});
const sortNumber = (a, b) => a - b;
const unique = (arr) => [...new Set(arr)];
const last = (arr) => arr.length > 0 ? arr.at(-1) : void 0;
const isNumberArr = (value) => Array.isArray(value) && (value.length === 0 || typeof value[0] === "number");
const createPageSets = ({
  activePage,
  around = 2,
  pages
}) => {
  const numbers = [...Array(pages).keys()].map((p) => p + 1);
  const activeIndex = numbers.indexOf(activePage);
  const firstPage = numbers[0];
  const lastPage = numbers.at(-1);
  const aroundStartIndex = activeIndex - around <= 0 ? 0 : activeIndex - around;
  const aroundEndIndex = activeIndex + 1 + around >= numbers.length ? numbers.length : activeIndex + 1 + around;
  const startSlice = numbers.slice(0, 1 + 2 * around);
  const aroundSlice = numbers.slice(aroundStartIndex, aroundEndIndex);
  const endSlice = numbers.slice(pages - 1 - 2 * around);
  const middleSlice = unique([startSlice.includes(activePage) && startSlice, endSlice.includes(activePage) && endSlice, aroundSlice].filter((value) => value !== false).flat(1)).sort(sortNumber);
  return [!middleSlice.includes(firstPage) && [firstPage], middleSlice, lastPage !== void 0 && !middleSlice.includes(lastPage) && [lastPage]].filter(isNumberArr).filter((set) => !!set.length);
};
const paginationButton = clsx(typographyClassName.bodyBase, "cb_Pagination_paginationButton_p1x5");
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Pagination_Root_r17j",
  propsAsIs: false
});
const ThreeDotsRoot = /* @__PURE__ */ styled("div")({
  name: "ThreeDotsRoot",
  class: "cb_Pagination_ThreeDotsRoot_t1k8",
  propsAsIs: false
});
const ThreeDots = () => /* @__PURE__ */ jsx(ThreeDotsRoot, {
  children: /* @__PURE__ */ jsx(SvgMorehorizontal, {})
});
const Pagination = ({
  activePage,
  "aria-label": ariaLabel = "Pagination",
  disabled,
  onPageChange = () => {
  },
  pages,
  showPrevNext = true,
  ...rest
}) => {
  const onPreviousPageClick = () => onPageChange(activePage - 1);
  const onNextPageClick = () => onPageChange(activePage + 1);
  const pageNumberSets = useMemo(() => createPageSets({
    activePage,
    pages
  }), [activePage, pages]);
  return /* @__PURE__ */ jsxs(Root$1, {
    role: "navigation",
    ...rest,
    "aria-label": ariaLabel,
    children: [!!showPrevNext && /* @__PURE__ */ jsx("button", {
      className: paginationButton,
      disabled: disabled || activePage === 1,
      onClick: onPreviousPageClick,
      title: "Previous page",
      type: "button",
      children: /* @__PURE__ */ jsx(SvgCaretleft, {
        height: "10px"
      })
    }), pageNumberSets.map((numberSet, i) => {
      const isLastNumberSet = i === pageNumberSets.length - 1;
      const elem = /* @__PURE__ */ jsx(React.Fragment, {
        children: numberSet.map((page) => /* @__PURE__ */ jsx("button", {
          "aria-current": activePage === page ? "page" : void 0,
          className: paginationButton,
          disabled,
          onClick: () => {
            if (onPageChange) {
              onPageChange(page);
            }
          },
          title: `Page ${page} of ${pages}`,
          type: "button",
          children: page
        }, page))
      }, i);
      return isLastNumberSet ? [elem] : [elem, /* @__PURE__ */ jsx(ThreeDots, {}, `${i}n`)];
    }), !!showPrevNext && /* @__PURE__ */ jsx("button", {
      className: paginationButton,
      disabled: disabled || activePage === last(last(pageNumberSets) || []),
      onClick: onNextPageClick,
      title: "Next page",
      type: "button",
      children: /* @__PURE__ */ jsx(SvgCaretright, {
        height: "10px"
      })
    })]
  });
};
const DEFAULT_PAGE_SIZE_OPTIONS = [15, 30, 50, 100];
const _exp3 = () => ({
  $rounded
}) => $rounded ? "8px" : 0;
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_DataTable_Root_rhsl",
  propsAsIs: false,
  vars: {
    "rhsllyf-0": [_exp3()]
  }
});
const _exp4 = () => ({
  $horizontalPadding
}) => ({
  none: 0,
  narrow: 16,
  wide: 24
})[$horizontalPadding];
const _exp6 = () => ({
  $rounded
}) => $rounded ? "8px 8px 0 0" : 0;
const Header = /* @__PURE__ */ styled("header")({
  name: "Header",
  class: "cb_DataTable_Header_h199",
  propsAsIs: false,
  vars: {
    "h199mn38-0": [_exp4(), "px"],
    "h199mn38-1": [_exp6()]
  }
});
const _exp7 = () => ({
  $horizontalPadding,
  $verticalColumnBorders
}) => $verticalColumnBorders ? 0 : {
  none: 0,
  narrow: 16,
  wide: 24
}[$horizontalPadding] / 2;
const Content = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_DataTable_Content_c1t3",
  propsAsIs: false,
  vars: {
    "c1t3lsvq-0": [_exp7(), "px"]
  }
});
const EmptyContainer = /* @__PURE__ */ styled("div")({
  name: "EmptyContainer",
  class: "cb_DataTable_EmptyContainer_ew4o",
  propsAsIs: false
});
const EmptySectionContentColumn = /* @__PURE__ */ styled("td")({
  name: "EmptySectionContentColumn",
  class: "cb_DataTable_EmptySectionContentColumn_e1m0",
  propsAsIs: false
});
const SpinnerContainer = /* @__PURE__ */ styled("div")({
  name: "SpinnerContainer",
  class: "cb_DataTable_SpinnerContainer_su9v",
  propsAsIs: false
});
const _exp9 = () => ({
  $offset
}) => $offset;
const _exp11 = () => ({
  $rounded
}) => $rounded ? "0 0 8px 8px" : 0;
const SpinnerOverlayContainer = /* @__PURE__ */ styled("div")({
  name: "SpinnerOverlayContainer",
  class: "cb_DataTable_SpinnerOverlayContainer_s4ar",
  propsAsIs: false,
  vars: {
    "s4arp60-0": [_exp9()],
    "s4arp60-1": [_exp11()]
  }
});
const _exp12 = () => ({
  $rounded
}) => $rounded ? "8px" : 0;
const _exp13 = () => ({
  $tableLayout
}) => $tableLayout;
const Table = /* @__PURE__ */ styled("table")({
  name: "Table",
  class: "cb_DataTable_Table_t1ce",
  propsAsIs: false,
  vars: {
    "t1cetnoq-0": [_exp12()],
    "t1cetnoq-1": [_exp13()]
  }
});
const TableHeader = /* @__PURE__ */ styled("thead")({
  name: "TableHeader",
  class: "cb_DataTable_TableHeader_t1fu",
  propsAsIs: false
});
const _exp15 = () => ({
  $verticalSpacing
}) => $verticalSpacing === "spacious" ? 56 : 36;
const _exp16 = () => ({
  $verticalColumnBorders
}) => $verticalColumnBorders ? "16px" : "8px";
const _exp17 = () => ({
  $verticalColumnBorders
}) => $verticalColumnBorders ? "1px" : 0;
const _exp21 = () => ({
  $rounded
}) => $rounded ? "8px" : 0;
const _exp22 = () => ({
  $horizontalPadding
}) => ({
  none: 0,
  narrow: 16,
  wide: 24
})[$horizontalPadding];
const HeaderRow = /* @__PURE__ */ styled("tr")({
  name: "HeaderRow",
  class: "cb_DataTable_HeaderRow_hbwi",
  propsAsIs: false,
  vars: {
    "hbwihpd-0": [_exp15(), "px"],
    "hbwihpd-1": [_exp16()],
    "hbwihpd-2": [_exp17()],
    "hbwihpd-3": [_exp21()],
    "hbwihpd-4": [_exp22(), "px"]
  }
});
const _exp23 = () => HeaderColumn;
const HeaderSelectionColumn = /* @__PURE__ */ styled(_exp23())({
  name: "HeaderSelectionColumn",
  class: "cb_DataTable_HeaderSelectionColumn_h16k",
  propsAsIs: true
});
const _exp24 = () => ({
  $verticalSpacing
}) => $verticalSpacing === "spacious" ? "56px" : "36px";
const _exp27 = () => ({
  $horizontalPadding
}) => ({
  none: 0,
  narrow: 16,
  wide: 24
})[$horizontalPadding];
const _exp28 = () => ({
  $rounded
}) => $rounded ? "0 0 8px 8px" : 0;
const _exp30 = () => ({
  $rounded
}) => $rounded ? "8px" : 0;
const Body = /* @__PURE__ */ styled("tbody")({
  name: "Body",
  class: "cb_DataTable_Body_by2r",
  propsAsIs: false,
  vars: {
    "by2rxf9-0": [_exp24()],
    "by2rxf9-1": [_exp27(), "px"],
    "by2rxf9-2": [_exp28()],
    "by2rxf9-3": [_exp30()]
  }
});
const _exp31 = () => ({
  $verticalColumnBorders
}) => $verticalColumnBorders ? "16px" : "8px";
const _exp32 = () => ({
  $verticalColumnBorders
}) => $verticalColumnBorders ? "1px" : 0;
const Row = /* @__PURE__ */ styled("tr")({
  name: "Row",
  class: "cb_DataTable_Row_r14z",
  propsAsIs: false,
  vars: {
    "r14zz1vk-0": [_exp31()],
    "r14zz1vk-1": [_exp32()]
  }
});
const SectionTitle = /* @__PURE__ */ styled("div")({
  name: "SectionTitle",
  class: "cb_DataTable_SectionTitle_s1ax",
  propsAsIs: false
});
const DefaultEmptySectionContent = /* @__PURE__ */ styled("div")({
  name: "DefaultEmptySectionContent",
  class: "cb_DataTable_DefaultEmptySectionContent_ds0v",
  propsAsIs: false
});
const _exp44 = () => ({
  $align
}) => ({
  left: "start",
  center: "center",
  right: "end"
})[$align];
const _exp45 = () => ({
  $alignVertical
}) => $alignVertical;
const Column = /* @__PURE__ */ styled("td")({
  name: "Column",
  class: "cb_DataTable_Column_cdyv",
  propsAsIs: false,
  vars: {
    "cdyvciy-0": [_exp44()],
    "cdyvciy-1": [_exp45()]
  }
});
const SectionColumn = /* @__PURE__ */ styled("td")({
  name: "SectionColumn",
  class: "cb_DataTable_SectionColumn_s6d3",
  propsAsIs: false
});
const _exp46 = () => Column;
const SelectionColumn = /* @__PURE__ */ styled(_exp46())({
  name: "SelectionColumn",
  class: "cb_DataTable_SelectionColumn_s1xm",
  propsAsIs: true
});
const _exp48 = () => ({
  $horizontalPadding
}) => ({
  none: 0,
  narrow: 16,
  wide: 24
})[$horizontalPadding];
const Footer = /* @__PURE__ */ styled("footer")({
  name: "Footer",
  class: "cb_DataTable_Footer_f1rf",
  propsAsIs: false,
  vars: {
    "f1rfs4eq-0": [_exp48(), "px"]
  }
});
const _exp49 = () => ({
  $horizontalPadding
}) => ({
  none: 0,
  narrow: 16,
  wide: 24
})[$horizontalPadding];
const PaginationContainer = /* @__PURE__ */ styled("div")({
  name: "PaginationContainer",
  class: "cb_DataTable_PaginationContainer_ptmv",
  propsAsIs: false,
  vars: {
    "ptmv4sv-0": [_exp49(), "px"]
  }
});
const _exp50 = () => Pagination;
const StyledPagination = /* @__PURE__ */ styled(_exp50())({
  name: "StyledPagination",
  class: "cb_DataTable_StyledPagination_s130",
  propsAsIs: true
});
const _exp51 = () => PageSizeSelector;
const StyledPageSizeSelector = /* @__PURE__ */ styled(_exp51())({
  name: "StyledPageSizeSelector",
  class: "cb_DataTable_StyledPageSizeSelector_scdf",
  propsAsIs: true
});
const EmptyIconContainer = /* @__PURE__ */ styled("div")({
  name: "EmptyIconContainer",
  class: "cb_DataTable_EmptyIconContainer_e1td",
  propsAsIs: false
});
function DataTable({
  className,
  columns,
  componentProps,
  dataSource,
  elevation,
  emptyMessage = {
    title: "No data"
  },
  footer,
  getRowKey,
  header,
  highlightSelectedRow,
  highlightUnclickableRowOnHover,
  horizontalPadding = "narrow",
  isRowClickable,
  loading,
  onColumnSortChange,
  onRowClick,
  pagination,
  renderSpinnerOnTop = false,
  roundedCorners = false,
  rowSelection,
  sectionsConfig,
  sortedColumn,
  style,
  tableLayout = "auto",
  verticalColumnBorders = false,
  verticalSpacing = "spacious"
}) {
  const allRowKeys = useMemo(() => dataSource.map(getRowKey), [dataSource, getRowKey]);
  const [activeKeyPressedRowKey, setKeyPressedRowKey] = useState();
  const hasFooterElement = !!footer || !!pagination;
  const recordSectionMap = useMemo(() => sectionsConfig ? dataSource.reduce((acc, record) => {
    const sectionId = sectionsConfig.getRowSectionId(record);
    if (acc[sectionId]) {
      acc[sectionId] = [...acc[sectionId], record];
    } else {
      acc[sectionId] = [record];
    }
    return acc;
  }, {}) : void 0, [sectionsConfig, dataSource]);
  const sections = useMemo(() => {
    if (!sectionsConfig) {
      return [{
        id: void 0,
        name: "",
        render: void 0,
        records: dataSource
      }];
    }
    const sectionIds = sectionsConfig.sections.map((conf) => conf.id);
    return sectionIds.map((sectionId) => {
      const conf = sectionsConfig.sections.find((s) => s.id === sectionId);
      return {
        id: sectionId,
        name: (conf == null ? void 0 : conf.name) || sectionId,
        render: conf == null ? void 0 : conf.render,
        records: recordSectionMap && recordSectionMap[sectionId] ? recordSectionMap[sectionId] : []
      };
    });
  }, [recordSectionMap, sectionsConfig, dataSource]);
  const renderHeaderColumns = () => {
    let skipColumnsCount = 0;
    return columns.map(({
      alignName = "left",
      className: columnClassName,
      id,
      info,
      name,
      nameColSpan,
      renderName = true,
      sortDirections = [],
      style: columnStyle
    }) => {
      if (skipColumnsCount > 0) {
        skipColumnsCount = skipColumnsCount - 1;
        return null;
      }
      if (nameColSpan && nameColSpan > 1) {
        skipColumnsCount = nameColSpan - 1;
      }
      return /* @__PURE__ */ jsx(HeaderColumn, {
        align: alignName,
        className: columnClassName,
        colSpan: nameColSpan,
        info,
        onSortChange: onColumnSortChange ? (direction) => {
          onColumnSortChange(id, direction);
        } : void 0,
        sortDirection: (sortedColumn == null ? void 0 : sortedColumn.id) === id ? sortedColumn.direction : void 0,
        sortDirections,
        style: columnStyle,
        children: renderName && name
      }, id);
    });
  };
  return /* @__PURE__ */ jsxs(Root, {
    $rounded: roundedCorners,
    className: clsx(className, elevation && elevationClassName[elevation], typographyClassName.Body3),
    style,
    children: [!!header && /* @__PURE__ */ jsx(Header, {
      $horizontalPadding: horizontalPadding,
      $rounded: roundedCorners,
      children: header
    }), /* @__PURE__ */ jsxs(Content, {
      $horizontalPadding: horizontalPadding,
      $verticalColumnBorders: verticalColumnBorders,
      children: [/* @__PURE__ */ jsxs(Table, {
        $rounded: roundedCorners && !header,
        $tableLayout: tableLayout,
        children: [/* @__PURE__ */ jsx(TableHeader, {
          children: /* @__PURE__ */ jsxs(HeaderRow, {
            $horizontalPadding: horizontalPadding,
            $rounded: roundedCorners && !header,
            $verticalColumnBorders: verticalColumnBorders,
            $verticalSpacing: verticalSpacing,
            children: [!!rowSelection && !(rowSelection == null ? void 0 : rowSelection.hideCheckboxColumn) && /* @__PURE__ */ jsx(HeaderSelectionColumn, {
              align: "left",
              children: /* @__PURE__ */ jsx(InputCheckbox, {
                checked: dataSource.length > 0 && allRowKeys.every((key) => rowSelection.selectedRowKeys.includes(key)),
                onChange: () => {
                  if (rowSelection.onSelectAll) {
                    rowSelection.onSelectAll();
                  }
                },
                partiallyChecked: allRowKeys.some((key) => rowSelection.selectedRowKeys.includes(key))
              })
            }), renderHeaderColumns()]
          })
        }), (renderSpinnerOnTop || !loading) && /* @__PURE__ */ jsx(Body, {
          $horizontalPadding: horizontalPadding,
          $rounded: roundedCorners && !hasFooterElement,
          $verticalSpacing: verticalSpacing,
          children: sections.map(({
            id: sectionId,
            name: sectionName,
            records,
            render: renderSection = ({
              sectionName: sectionName2
            }) => /* @__PURE__ */ jsx(SectionTitle, {
              className: typographyClassName.Overline3,
              children: sectionName2
            })
          }) => (records.length > 0 || (sectionsConfig == null ? void 0 : sectionsConfig.showEmptySections)) && /* @__PURE__ */ jsxs(React.Fragment, {
            children: [!!sectionId && /* @__PURE__ */ jsx("tr", {
              title: sectionName === void 0 ? void 0 : `Section ${sectionName}`,
              children: /* @__PURE__ */ jsx(SectionColumn, {
                colSpan: columns.length,
                children: renderSection({
                  ...componentProps,
                  records,
                  sectionName
                })
              })
            }), records.length === 0 ? /* @__PURE__ */ jsx("tr", {
              children: /* @__PURE__ */ jsx(EmptySectionContentColumn, {
                colSpan: columns.length,
                children: !!sectionsConfig && !!sectionsConfig.renderEmptySectionContent ? sectionsConfig.renderEmptySectionContent({
                  ...componentProps,
                  sectionName
                }) : /* @__PURE__ */ jsx(DefaultEmptySectionContent, {
                  children: "No data in this section"
                })
              })
            }) : records.map((record, rowIndex) => {
              var _a;
              const clickDisabled = !!onRowClick && !!isRowClickable && !isRowClickable(record);
              const rowKey = getRowKey(record);
              const selected = (_a = rowSelection == null ? void 0 : rowSelection.selectedRowKeys) == null ? void 0 : _a.includes(rowKey);
              return /* @__PURE__ */ jsxs(Row, {
                $horizontalPadding: horizontalPadding,
                $verticalColumnBorders: verticalColumnBorders,
                $verticalSpacing: verticalSpacing,
                "aria-disabled": clickDisabled,
                "data-clickable": onRowClick ? true : void 0,
                "data-highlight-selected": highlightSelectedRow ? true : void 0,
                "data-hover-highlight": highlightUnclickableRowOnHover ? true : void 0,
                "data-selected": Boolean(selected) || activeKeyPressedRowKey === rowKey,
                onClick: onRowClick && !clickDisabled ? (event) => onRowClick(rowKey, record, event) : void 0,
                onKeyDown: onRowClick && !clickDisabled ? (event) => {
                  if (event.key === " ") {
                    setKeyPressedRowKey(rowKey);
                    onRowClick(rowKey, record, event);
                  }
                } : void 0,
                onKeyUp: () => setKeyPressedRowKey(void 0),
                role: onRowClick ? "button" : void 0,
                tabIndex: onRowClick ? 0 : void 0,
                children: [!!rowSelection && !(rowSelection == null ? void 0 : rowSelection.hideCheckboxColumn) && /* @__PURE__ */ jsx(SelectionColumn, {
                  $align: "left",
                  $alignVertical: "middle",
                  className: typographyClassName.Body3,
                  children: /* @__PURE__ */ jsx(InputCheckbox, {
                    checked: selected,
                    onChange: () => {
                      const newKeys = rowSelection.selectedRowKeys.includes(rowKey) ? rowSelection.selectedRowKeys.filter((key) => key !== rowKey) : [...rowSelection.selectedRowKeys, rowKey];
                      const records2 = dataSource.filter((d) => newKeys.includes(getRowKey(d)));
                      rowSelection.onChange(newKeys, records2);
                    },
                    onClick: (event) => event.stopPropagation()
                  })
                }), columns.map(({
                  alignContent = "left",
                  alignContentVertical = "middle",
                  id,
                  render
                }) => /* @__PURE__ */ jsx(Column, {
                  $align: alignContent,
                  $alignVertical: alignContentVertical,
                  className: typographyClassName.Body3,
                  children: render({
                    ...componentProps,
                    record,
                    rowIndex
                  })
                }, id))]
              }, rowKey);
            })]
          }, sectionId || "no-id"))
        })]
      }), !(sectionsConfig == null ? void 0 : sectionsConfig.showEmptySections) && (!loading || renderSpinnerOnTop) && dataSource.length === 0 && /* @__PURE__ */ jsx(EmptyContainer, {
        children: /* @__PURE__ */ jsx(Empty, {
          description: emptyMessage.description,
          footer: emptyMessage.footer,
          image: (emptyMessage == null ? void 0 : emptyMessage.icon) ? /* @__PURE__ */ jsx(EmptyIconContainer, {
            children: emptyMessage == null ? void 0 : emptyMessage.icon
          }) : void 0,
          title: emptyMessage.title
        })
      }), !!loading && !renderSpinnerOnTop && /* @__PURE__ */ jsx(SpinnerContainer, {
        children: /* @__PURE__ */ jsx(Spinner, {
          size: "large"
        })
      }), !!loading && !!renderSpinnerOnTop && /* @__PURE__ */ jsx(SpinnerOverlayContainer, {
        $offset: verticalSpacing === "compact" ? "36px" : "56px",
        $rounded: !footer && !pagination && !!roundedCorners,
        className: elevation && elevationClassName[elevation],
        children: /* @__PURE__ */ jsx(Spinner, {
          size: "large"
        })
      })]
    }), !!footer && !pagination && /* @__PURE__ */ jsx(Footer, {
      $horizontalPadding: horizontalPadding,
      children: footer
    }), !!pagination && /* @__PURE__ */ jsx(Footer, {
      $horizontalPadding: "none",
      children: /* @__PURE__ */ jsxs(PaginationContainer, {
        $horizontalPadding: horizontalPadding,
        children: [/* @__PURE__ */ jsx(StyledPagination, {
          activePage: pagination.activePage,
          disabled: pagination.disableWhenLoading && loading,
          onPageChange: pagination.onPageChange,
          pages: pagination.pageCount
        }), pagination.pageSize !== void 0 && /* @__PURE__ */ jsx(StyledPageSizeSelector, {
          onChange: pagination.onPageSizeChange,
          options: pagination.pageSizeOptions || DEFAULT_PAGE_SIZE_OPTIONS,
          value: pagination.pageSize
        })]
      })
    })]
  });
}
export {
  DataTable,
  Pagination
};
//# sourceMappingURL=index.js.map
